/**
 * Video section – activates deferred <template> video embeds,
 * handles click-to-play with cover image, and sidebar scroll animation.
 */
(function () {
  function initVideoSection(section) {
    const vid = section.querySelector('.vid');
    if (!vid) return;
    const player = vid.querySelector('.vid__player');
    const template = player ? player.querySelector('template') : null;
    const cover = vid.querySelector('.vid__cover');
    const playBtn = vid.querySelector('.vid__play-btn');
    const isAutoplay = !cover;

    function activateVideo() {
      if (!template) return;
      const content = template.content.cloneNode(true);
      template.parentNode.insertBefore(content, template.nextSibling);
      template.remove();

      var video = player ? player.querySelector('video') : null;
      if (video) {
        var alt = video.getAttribute('alt') || video.getAttribute('aria-label') ||'';
        var img = video.querySelector('img');
        if (img && !img.getAttribute('alt')) img.setAttribute('alt', alt);
      }
    }

    if (isAutoplay) {
      // Autoplay mode: activate video immediately
      activateVideo();
    } else {
      // Click-to-play mode: activate on cover or play button click
      function handlePlay() {
        activateVideo();

        // For Shopify-hosted video, ensure it plays
        const video = player ? player.querySelector('video') : null;
        if (video) {
          video.play();
        }

        if (vid) vid.classList.add('vid--playing');
      }

      if (cover) cover.addEventListener('click', handlePlay);
      if (playBtn) playBtn.addEventListener('click', handlePlay);
    }

    // Sidebar scroll animation (IntersectionObserver)
    if (vid && vid.classList.contains('vid--animate-content')) {
      const sidebarInner = vid.querySelector('.vid__sidebar-inner');
      if (sidebarInner && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.2 }
        );
        observer.observe(sidebarInner);
      }
    }
  }

  // Init all video sections on page load
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.section-video').forEach(initVideoSection);
  });

  // Support Shopify Theme Editor section lifecycle
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.classList.contains('section-video')) {
        initVideoSection(e.target);
      }
    });
  }
})();
